import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { CustomMsalRedirectComponent } from './app/shared/custom-msal-redirect/custom-msal-redirect.component';
import { environment } from './environments/environment';

if (environment.maintenanceMode === 'true') {
  window.location.href = 'assets/maintenance.html';
} else {
  bootstrapApplication(AppComponent, appConfig)
    .then((ref) => ref.bootstrap(CustomMsalRedirectComponent))
    .catch((err) => console.error(err));
}
